import React from "react";
import Icons from "components/icons";
import { Localize } from "components/service";
import StaffCheckInHistoryChangedFieldsField from "../fields/staff-check-in-history-changed-fields-field";
import {
    formatStaffCheckInHistoryCoordinate,
    formatStaffCheckInHistoryDateTime,
    formatStaffCheckInHistoryRadius,
    getStaffCheckInHistoryActor,
    getStaffCheckInHistoryChangedFields,
} from "./staff-check-in-history-presentation-helper";


const columns = [
    {
        title: <Localize>STAFF_MANAGEMENT.History_ChangedBy</Localize>,
        dataIndex: "changedBy",
        className: "staff-check-in-history-table__column--actor",
        width: 220,
    },
    {
        title: <Localize>STAFF_MANAGEMENT.History_DateTime</Localize>,
        dataIndex: "createdAt",
        width: 190,
    },
    {
        title: <Localize>STAFF_MANAGEMENT.History_ChangedFields</Localize>,
        dataIndex: "changedFields",
        width: 260,
    },
    {
        title: <Localize>STAFF_MANAGEMENT.History_NewPosition</Localize>,
        dataIndex: "newPosition",
        width: 260,
    },
    {
        title: <Localize>STAFF_MANAGEMENT.Action_View</Localize>,
        dataIndex: "details",
        className: "staff-check-in-history-table__column--view",
        width: 140,
    },
];

const data = (logs = [], currentObj = {}) => logs.map((log, index) => {
    const fields = getStaffCheckInHistoryChangedFields(log);

    return {
        key: log.id ?? index,
        changedBy: getStaffCheckInHistoryActor(log),
        createdAt: formatStaffCheckInHistoryDateTime(log.created_at),
        changedFields: fields.length ? <StaffCheckInHistoryChangedFieldsField fields={ fields } /> : "—",
        newPosition: (
            <span className="staff-check-in-history__position">
                <span>
                    { formatStaffCheckInHistoryCoordinate(log.new_latitude) },{ " " }
                    { formatStaffCheckInHistoryCoordinate(log.new_longitude) }
                </span>
                <span>
                    <Localize>STAFF_MANAGEMENT.History_Radius</Localize>:{ " " }
                    { formatStaffCheckInHistoryRadius(log.new_radius) }
                </span>
            </span>
        ),
        details: (
            <button
                type="button"
                className="btn-text-link staff-audit-scan-location staff-audit-scan-location--view"
                onClick={ () => currentObj.onDetails?.(log) }>
                <span className="d-flex align-items-center justify-content-center staff-audit-scan-location__icon" aria-hidden="true">
                    <Icons.StaffLocationMap />
                </span>
                <span className="staff-audit-scan-location__label">
                    <Localize>STAFF_MANAGEMENT.Action_View</Localize>
                </span>
            </button>
        ),
    };
});

const StaffCheckInHistoryTableHelper = { columns, data };

export default StaffCheckInHistoryTableHelper;
